import { useId } from 'react';

import Grid from 'components/Grid';
import DateInput from 'components/inputs/DateInput';
import BodyText from 'components/text/BodyText';

import useTranslation from './hooks/useTranslation';

import { DATE_SEPARATOR, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DateRangePickerInputs: FunctionComponent<Props> = ({
    endValue,
    onBlur,
    onChange,
    onEndClick,
    onStartClick,
    refs,
    startValue,
    testId = TEST_ID
}) => {
    const { endInputRef, startInputRef } = refs;

    const startInputId = useId();
    const endInputId = useId();
    const { END_DATE_PLACEHOLDER, START_DATE_PLACEHOLDER } = useTranslation();

    return (
        <Grid className={styles.dateRangePickerInputs} testId={testId}>
            <DateInput
                id={startInputId}
                onBlur={onBlur}
                onChange={onChange}
                onClick={onStartClick}
                placeholder={START_DATE_PLACEHOLDER}
                ref={startInputRef}
                testId={`${TEST_ID}-start`}
                value={startValue ?? ''}
            />

            <BodyText className={styles.separator} text={DATE_SEPARATOR} />

            <DateInput
                id={endInputId}
                onBlur={onBlur}
                onChange={onChange}
                onClick={onEndClick}
                placeholder={END_DATE_PLACEHOLDER}
                ref={endInputRef}
                testId={`${TEST_ID}-end`}
                value={endValue ?? ''}
            />
        </Grid>
    );
};

export default DateRangePickerInputs;
